module.exports = "<div *ngIf=\"blogItem\">\n    <h1>{{blogItem.postTitle}}</h1>\n    <p>Posted on {{blogItem.postDate | date}}</p>\n    <p [innerHtml]=\"blogItem.postCont\"></p>\n</div>\n<hr/>\n<div id=\"disqus_thread\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/blog/blog-item.component.html
// module id = ./src/app/blog/blog-item.component.html
// module chunks = main